/*
	文件下载的axios
*/
import axios from 'axios'
import cookies from '../../libs/util.cookies'
import { Message } from 'element-ui'

const formAxios = axios.create({
	baseURL: process.env.BASE_API || '',
	timeout: 120000,
	responseType: 'arraybuffer'
})

formAxios.interceptors.request.use(
	(config) => {
		if (process.env.NODE_ENV === 'production') {
			// 处理重复
			if (config.url.indexOf('/KYWB') != 0) {
				config.url = '/KYWB' + config.url
			}
			// 地图数据不需要加/nginx前缀
			/* if (config.url.indexOf('map/json/province') > -1) {
				config.url = config.url.substr(4)
			} */
		}
	  const token = cookies.get('token')
	    if (config.method === 'get') {
	      if (config.params) {
	        config.params.appCode = 'YHGHT'
	      } else {
	        config.params = {}
	        config.params.appCode = 'YHGHT'
	      }
	    }
	    if (config.method === 'post') {
	      if (config.data) {
	        config.data.appCode = 'YHGHT'
	      } else {
	        config.data = {}
	        config.data.appCode = 'YHGHT'
	      }
	    }
	    if (token) {
	      config.headers = {
	        ...config.headers,
	        Authorization: 'Bearer ' + token,
	        appCode: 'YHGHT'

	      }
	    } else {
	      config.headers = {
	        ...config.headers,
	        appCode: 'YHGHT'
	      }
	    }
	   return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

formAxios.interceptors.response.use(
	response => {
		if (response.status === 200) {
			const disposition = response.headers['content-disposition']
			console.log(disposition,'disposition')
			let fileName = decodeURIComponent(
				disposition.substring(disposition.indexOf('filename=') + 9, disposition.length)
			)
			let nameArr = fileName.match(/\"[\S\s]+\"/)
			fileName = nameArr ? nameArr[0].replace(/\"/g, '') : '文件名'
			const blob = new Blob([response.data])
			const url = URL.createObjectURL(blob)
			const a = document.createElement('a')
			a.download = fileName
			a.href = url
			a.setAttribute('download', `${fileName}`)
			a.click()
			URL.revokeObjectURL(a)
			a.remove()
			return url
		} else {
			sessionStorage.removeItem('account')
			window.location = window.location.href.split('#')[0] + '#/login'
			return false
		}
	},
	error => {
		console.log(error)
		Message({
			message: error.message,
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error)
	}
)

export default formAxios



// WEBPACK FOOTER //
// ./src/plugin/axios/formAxios.js